'use client'

import { useSearchStore } from '@stores/search.store'

import type { JSX } from 'react'

import useSearchDispatcher from '@hooks/useSearchDispatcher'
import { searchSubmittedEvent } from '@lib/analytics-events'

import SearchBar from '../design-system/search-bar'

/** The search bar of the browse pages: tracks the search, then goes to the results. */
export default function BrowseSearch(): JSX.Element {
  const nextSearch = useSearchStore((state) => state.nextSearch)
  const dispatch = useSearchDispatcher()

  return (
    <SearchBar
      initialJob={nextSearch.job?.micro ? nextSearch.job : undefined}
      initialLocation={nextSearch.location?.name ? nextSearch.location : undefined}
      submitProps={{ 'data-pw': 'search-btn' }}
      onSubmit={({ job, location }): void => {
        searchSubmittedEvent({ ...nextSearch, job, location, salary: { min: 0, type: 'PER_ANNUM' } }, 'Browse Jobs')
        dispatch({ job, location })
      }}
    />
  )
}
